/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import styles from "./index.module.css";
import useOnClickOutside from "../../utils/hooks/useOnClickOutside";
import useOnEscape from "../../utils/hooks/useOnEscape";

const Flyout = ({
    isOpen,
    flyoutRef,
    onAttemptClose,
    helperClass,
    ...props
}) => {
    const handleEsc =
        () => {
            if (
                isOpen &&
                onAttemptClose
            ) {
                onAttemptClose();
            }
        };

    useOnClickOutside(flyoutRef, () => onAttemptClose());
    useOnEscape((e) => handleEsc());

    return (
        <div
            ref={flyoutRef}
            role="dialog"
            className={[
                styles.flyout,
                helperClass || "",
                !isOpen ? styles.flyoutHidden : "",
            ].join(" ")}
        >
            <div className={styles.flyoutContent}>
                {props.children}
            </div>
        </div>
    );
};

export default Flyout;
